import { useState } from "react"


const createChildren = (parent) => parent.children = []

const pushNodeByParentKey = (node, lists, map, parentPosition, parentKey, len) => {

    if (!lists[parentPosition][map[parentPosition][node[parentKey]]]?.children) {
        createChildren(lists[parentPosition][map[parentPosition][node[parentKey]]])
    }
    lists[parentPosition][map[parentPosition][node[parentKey]]].children.push(node)

    //     if (len < 2100) {
    //         let length = lists[parentPosition][map[parentPosition][node[parentKey]]].children.length
    //         let arr = lists[parentPosition][map[parentPosition][node[parentKey]]].children
        
    //         for (let i = 0; i < length; i++) {
    //             for (let j = 0; j < length; j++) {
                
    //                 if (arr[j]?.number && arr[j]?.number) {
                            
    //                     if (Number(arr[j]?.number.split('.').slice(-1)) > Number(arr[j + 1]?.number.split('.').slice(-1))) {
    //                         let tmp = arr[j];
    //                         arr[j] = arr[j + 1];
    //                         arr[j + 1] = tmp;
    //                     }
                        
    //                 }
    //             }
    //         }
        
            
        
    //         lists[parentPosition][map[parentPosition][node[parentKey]]].children = arr

    // }

}

    




const pushNodeBySelfParentKey = (node, lists, map, index, selfParentKey) => {
    if (!lists[index][map[index][node[selfParentKey]]].children) {
        createChildren(lists[index][map[index][node[selfParentKey]]])
    }
    lists[index][map[index][node[selfParentKey]]].children.push(node)





}

export const makeTree = (lists, config) => {
    let map = [], node, nodeDo, roots = [], i, j, len


    len = lists[1].length
    
    for (i = 0; i < lists.length; i += 1) {
        for (j = 0; j < lists[i].length; j += 1) {
            if (!map[i]) {
                map.push({})
            }
            map[i][lists[i][j].id] = j
        }
    }
    
    for (i = 0; i < lists.length; i += 1) {
        const cfg = config[i]
        for (j = 0; j < lists[i].length; j += 1) {
            node = lists[i][j]

            if ( j === 0){
                nodeDo = lists[i][j]
            } else {}
                nodeDo = lists[i][j-1]
            
            

            if (cfg?.selfParentKey && cfg?.parentKey) {
                if (cfg?.root) {
                    if (node[cfg.parentKey] !== cfg.rootValue) {
                        if (node[cfg.selfParentKey] !== null) {
                            pushNodeBySelfParentKey(node, lists, map, i, cfg.selfParentKey)
                        } else {
                            pushNodeByParentKey(node, lists, map, cfg.parentPosition, cfg.parentKey)
                        }
                    } else {
                        roots.push(node)
                    }
                } else {
                    if (node[cfg.selfParentKey] !== null) {
                        pushNodeBySelfParentKey(node, lists, map, i, cfg.selfParentKey)
                    } else {
                        pushNodeByParentKey(node, lists, map, cfg.parentPosition, cfg.parentKey)
                    }
                }
            } else if (cfg?.parentKey) {
                
                if (cfg?.root) {
                    
                    if (node[cfg.parentKey] !== cfg.rootValue) {
                        
                        pushNodeByParentKey(node, lists, map, cfg.parentPosition, cfg.parentKey, len)
                    } else {
                        
                        roots.push(node)
                    }
                } else {
                    
                    pushNodeByParentKey(node, lists, map, cfg.parentPosition, cfg.parentKey, len)
                }
            } else {
                if (cfg?.root) {
                    if (node[cfg.selfParentKey] !== cfg.rootValue) {
                        pushNodeBySelfParentKey(node, lists, map, i, cfg.selfParentKey)
                    } else {
                        roots.push(node)
                    }
                } else {
                    pushNodeBySelfParentKey(node, lists, map, i, cfg.selfParentKey)
                }
            }
        }
    }

    return roots
}

export const sortArrayByName = (sortBy = 'name') => (a, b) => {
    if (a[sortBy].toLowerCase() > b[sortBy].toLowerCase()) return 1
    if (a[sortBy].toLowerCase() < b[sortBy].toLowerCase()) return -1
    return 0
}

export const sortArrayByID = (a, b) => {
    if (parseInt(a.id) > parseInt(b.id)) return 1
    if (parseInt(a.id) < parseInt(b.id)) return -1
    return 0
}

export const readFile = (file, onLoad) => {
    const reader = new FileReader()
    reader.onload = function (evt) {
        onLoad(evt.target.result)
    }
    reader.readAsText(file)
}
